import { client } from "utils";

export const getNormalizersRequest = () => client.get("normalizer");
